import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  color: ${({ theme }) => theme.colors.alert};
  margin: 0.5rem 0 0 0.5rem;
`;

export default ErrorWrapper